/**
 * URL Cleaner Utility
 *
 * Strips tracking parameters (UTM, etc.) from URLs.
 * Product URLs should be clean without marketing tracking params.
 */

// Tracking parameters to strip
const TRACKING_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'fbclid',
  'msclkid',
  'dclid',
  '_ga',
  '_gl',
  'mc_cid',
  'mc_eid',
];

/**
 * Remove tracking parameters from a URL
 * @param url - The URL to clean
 * @returns The URL without tracking parameters
 */
export function cleanProductUrl(url: string | undefined | null): string {
  if (!url) return '';

  try {
    const urlObj = new URL(url);

    // Remove tracking params
    for (const param of TRACKING_PARAMS) {
      urlObj.searchParams.delete(param);
    }

    return urlObj.toString();
  } catch {
    // If URL parsing fails, return original
    return url;
  }
}

/**
 * Check if a URL has tracking parameters
 * @param url - The URL to check
 * @returns true if URL contains tracking params
 */
export function hasTrackingParams(url: string | undefined | null): boolean {
  if (!url) return false;

  try {
    const urlObj = new URL(url);
    return TRACKING_PARAMS.some(param => urlObj.searchParams.has(param));
  } catch {
    return false;
  }
}
